import "./src/styles/global.css";
import { finishViewTransitionNavigation } from "./src/app/viewTransitionState";

export { wrapPageElement } from "./src/app";
export const onRouteUpdate = () => {
  finishViewTransitionNavigation();
};
